import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian tiếp nhận: ", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm thiết bị", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Chọn loại thiết bị", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Model thiết bị", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Hãng sản xuất", -1)
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Đơn vị cung cấp", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Giá trị tiếp nhận", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_19 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị:", -1)
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa phòng nhận:", -1)
const _hoisted_24 = {
  key: 0,
  class: "p-error"
}
const _hoisted_25 = { class: "list_button" }
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_27 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_28 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Tên thiết bị", -1)
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian tiếp nhận: ", -1)
const _hoisted_32 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm thiết bị", -1)
const _hoisted_34 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Chọn loại thiết bị", -1)
const _hoisted_36 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Model thiết bị", -1)
const _hoisted_38 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Hãng sản xuất", -1)
const _hoisted_40 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Đơn vị cung cấp", -1)
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Giá trị tiếp nhận", -1)
const _hoisted_44 = { class: "list_button" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_46 = { class: "p-fluid" }
const _hoisted_47 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_48 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_50 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_51 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Thêm thiết bị vào hệ thống" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputText, {
            id: "name",
            type: "text",
            modelValue: $setup.thietBi.tenThietBi,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.thietBi.tenThietBi) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Calendar, {
            id: "date",
            modelValue: $setup.date,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.date) = $event)),
            selectionMode: "single",
            dateFormat: "dd/mm/yy",
            showButtonBar: true,
            showIcon: true,
            manualInput: false,
            monthNavigator: true,
            yearNavigator: true,
            yearRange: "2000:2100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Dropdown, {
            id: "nhomThietBi",
            modelValue: $setup.idNhomThietBi,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.idNhomThietBi) = $event)),
            options: $setup.nhomThietBi,
            filter: "",
            optionLabel: "tenNhomThietBi",
            optionValue: "id",
            placeholder: "Vui lòng chọn nhóm thiết bị ...",
            onChange: $setup.loadChiTietLoaiThietBi
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_Dropdown, {
            id: "loaiThietBi",
            modelValue: $setup.loaiThietBi,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.loaiThietBi) = $event)),
            options: $setup.chiTietLoaiThietBi,
            filter: "",
            optionLabel: "tenLoaiThietBi",
            optionValue: "id",
            placeholder: "Vui lòng chọn loại thiết bị ...",
            onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.loadListThietBiById($setup.loaiThietBi)))
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputText, {
            id: "model",
            type: "text",
            modelValue: $setup.thietBi.model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.thietBi.model) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputText, {
            id: "hangsanxuat",
            type: "text",
            modelValue: $setup.thietBi.hangSanXuat,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.thietBi.hangSanXuat) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_InputText, {
            id: "donvicungcap",
            type: "text",
            modelValue: $setup.thietBi.donViCungCap,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.thietBi.donViCungCap) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_InputNumber, {
            id: "giaTriTiepNhan",
            modelValue: $setup.thietBi.giaTriTiepNhan,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.thietBi.giaTriTiepNhan) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Dialog, {
            visible: $setup.chuyen,
            "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (($setup.chuyen) = $event)),
            style: { width: '40vw'},
            breakpoints: { '1500px': '70vw', '1150px': '80vw' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, { header: "Chuyển tài sản" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_InputText, {
                        id: "khoaPhongNhan",
                        type: "text",
                        modelValue: $setup.tenThietBi,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.tenThietBi) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_Dropdown, {
                        id: "permission",
                        modelValue: $setup.thietBiChuyen.idKhoaPhongTiepNhan,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.thietBiChuyen.idKhoaPhongTiepNhan) = $event)),
                        options: $setup.khoaPhong,
                        optionLabel: "tenKhoaPhong",
                        optionValue: "id",
                        placeholder: "Vui lòng chọn khoa phòng nhận ..."
                      }, null, 8, ["modelValue", "options"]),
                      ($setup.thietBiChuyen.idKhoaPhongTiepNhan < 1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_24, "Vui lòng chọn khoa phòng nhận"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    ($setup.valid)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          label: "Chuyển",
                          icon: "pi pi-sync",
                          iconPos: "left",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.thucHienChuyenThietBi())),
                          style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          label: "Chuyển",
                          icon: "pi pi-sync",
                          iconPos: "left",
                          disabled: "disabled",
                          style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                        }))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_Dialog, {
            visible: $setup.capnhat,
            "onUpdate:visible": _cache[23] || (_cache[23] = ($event: any) => (($setup.capnhat) = $event)),
            style: { width: '70vw'},
            breakpoints: { '1500px': '70vw', '1150px': '80vw' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, { header: "Cập nhật thiết bị" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_InputText, {
                        id: "tenThietBi",
                        type: "text",
                        modelValue: $setup.thietBiUpdate.tenThietBi,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.thietBiUpdate.tenThietBi) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_Calendar, {
                        id: "date",
                        modelValue: $setup.dateUpdate,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.dateUpdate) = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        showButtonBar: true,
                        showIcon: true,
                        manualInput: false,
                        monthNavigator: true,
                        yearNavigator: true,
                        yearRange: "2000:2100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_Dropdown, {
                        id: "nhomThietBiUpdate",
                        modelValue: $setup.idNhomThietBi,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.idNhomThietBi) = $event)),
                        options: $setup.nhomThietBi,
                        filter: "",
                        optionLabel: "tenNhomThietBi",
                        optionValue: "id",
                        placeholder: "Vui lòng chọn nhóm thiết bị ...",
                        onChange: $setup.loadChiTietLoaiThietBi
                      }, null, 8, ["modelValue", "options", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createVNode(_component_Dropdown, {
                        id: "loaiThietBiUpdate",
                        modelValue: $setup.loaiThietBi,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.loaiThietBi) = $event)),
                        options: $setup.chiTietLoaiThietBi,
                        filter: "",
                        optionLabel: "tenLoaiThietBi",
                        optionValue: "id",
                        placeholder: "Vui lòng chọn loại thiết bị ...",
                        onChange: _cache[17] || (_cache[17] = ($event: any) => ($setup.loadListThietBiById($setup.loaiThietBi)))
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_InputText, {
                        id: "modelUpdate",
                        type: "text",
                        modelValue: $setup.thietBiUpdate.model,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.thietBiUpdate.model) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_InputText, {
                        id: "hangsanxuatUpdate",
                        type: "text",
                        modelValue: $setup.thietBiUpdate.hangSanXuat,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.thietBiUpdate.hangSanXuat) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_InputText, {
                        id: "donvicungcapUpdate",
                        type: "text",
                        modelValue: $setup.thietBiUpdate.donViCungCap,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.thietBiUpdate.donViCungCap) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_InputNumber, {
                        id: "giaTriTiepNhanUpdate",
                        modelValue: $setup.thietBiUpdate.giaTriTiepNhan,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.thietBiUpdate.giaTriTiepNhan) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    ($setup.validUpdate)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          label: "Cập nhật",
                          severity: "warning",
                          icon: "pi pi-pen-to-square",
                          iconPos: "left",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.thucHienCapNhatThietBi())),
                          style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          label: "Cập nhật",
                          severity: "warning",
                          icon: "pi pi-pen-to-square",
                          iconPos: "left",
                          disabled: "disabled",
                          style: {"width":"15vw","margin-right":"2vw","min-width":"100px"}
                        }))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ]),
      ($setup.validInput)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Thêm",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.createThietBi()))
          }))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "Thêm",
            icon: "pi pi-plus-circle",
            iconPos: "left",
            disabled: "disabled"
          })),
      _hoisted_45,
      _createVNode(_component_Panel, { header: "Danh sách thiết bị" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_DataTable, {
              loading: _ctx.isLoading,
              value: $setup.listThietBi,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              filters: $setup.filters,
              "onUpdate:filters": _cache[27] || (_cache[27] = ($event: any) => (($setup.filters) = $event)),
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['tenThietBi','giaTriTiepNhan'],
              currentPageReportTemplate: "Có tổng số {totalRecords} thiết bị",
              columnResizeMode: "fit | expand"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-filter-slash",
                    label: "Xoá",
                    class: "p-button-outlined",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.clearFilter())),
                    style: {"width":"6em"}
                  }),
                  _createElementVNode("span", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_InputText, {
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên thiết bị hoặc giá trị"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "tenThietBi",
                  header: "Tên thiết bị",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "thoiGianTiepNhan",
                  header: "Thời gian tiếp nhận",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianTiepNhan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "giaTriTiepNhan",
                  header: "Giá trị",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.moneyValue(data.giaTriTiepNhan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "thoiGianHaoMon",
                  header: "Thời gian hao mòn",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "tyLeHaoMon",
                  header: "Phần trăm hao mòn",
                  sortable: ""
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.tyLeHaoMon) + "% ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "khoaPhongTiepNhan",
                  header: "Khoa phòng tiếp nhận",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "khoaPhongHienTai",
                  header: "Khoa phòng hiện tại",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "khoaPhongChuyenGiao",
                  header: "Khoa phòng chuyển giao",
                  sortable: ""
                }),
                _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_Button, {
                          type: "button",
                          style: {"padding-right":"10px"},
                          label: "Chuyển",
                          icon: "pi pi-sync",
                          onClick: ($event: any) => ($setup.chuyenThietBi(slotProps.data.id))
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_Button, {
                          type: "button",
                          severity: "warning",
                          label: "Cập nhật",
                          icon: "pi pi-info-circle",
                          onClick: ($event: any) => ($setup.capNhatThietBi(slotProps.data.id))
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "value", "filters"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}